<ion-progress-bar
  *ngIf="!!(absences$ | async) === false"
  type="indeterminate"
></ion-progress-bar>
<ion-header>
  <ion-toolbar>
    <ion-buttons *ngIf="!modalView" slot="start">
      <app-toggle-menu-button></app-toggle-menu-button>
    </ion-buttons>
    <ion-title>{{ title }}</ion-title>
  </ion-toolbar>

  <ion-searchbar
    #searchInput
    (ionInput)="filterAbsences($event)"
    autocomplete="on"
  ></ion-searchbar>
</ion-header>
<ion-content
  (onEnterEvent)="onEnter()"
  (onEscape)="emitCancelEvent()"
  [dataSource$]="absences$"
  [selectedIndex]="selectedIndexAbsence"
  appTableRowMovement>
  <app-absence-selection-list-table
    #listOrTable
    (onClickEvent)="selected($event)"
    (onHoverEvent)="onHover($event)"
    *ngIf="(showTable$ | async) === true"
    [absenceList$]="absences$"
    [selectedIndex$]="selectedIndexAbsence"
    [tableColumns$]="tableColumns$">
  </app-absence-selection-list-table>

  <app-absence-selection-list-item
    #listOrTable
    (onClickEvent)="selected($event)"
    (onHoverEvent)="onHover($event)"
    *ngIf="(showTable$ | async) === false"
    [absenceList$]="absences$"
    [selectedIndex$]="selectedIndexAbsence"
    [tableColumns$]="tableColumns$">
  </app-absence-selection-list-item>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-tab-button (click)="emitCancelEvent()" slot="end">
      <ion-icon name="arrow-back"></ion-icon>
      <ion-label>{{ generalCancel | translate }}</ion-label>
    </ion-tab-button>
  </ion-toolbar>
</ion-footer>
